// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

/**
 * Game Configuration - Main Entry Point
 * 
 * Centralized configuration for all gameplay parameters.
 * This file imports and combines:
 * - GameMechanicsConfig.js: All game systems and balance parameters (aggregator)
 * - StarSystemsConfig.js: Star systems catalog and navigation data
 * 
 * Modify values in the respective config files to tune game balance and difficulty.
 * 
 * Usage: import GameConfig from './config/GameConfig';
 * Access: GameConfig.combat.escape.fuelCost
 */

import { gameMechanics } from './GameMechanicsConfig';
import { starSystems, starPositions } from './StarSystemsConfig';

// Combine all configuration into single object
const GameConfig = {
  ...gameMechanics,
  starSystems,
  starPositions
};

export default GameConfig;
